// Renders a cell value, prefixing a firm-override marker when the value was set
// by a firm-level override (see the legend under the consuming table). The
// visual "*" is hidden from assistive tech, which instead hears the "Firm
// override:" label.
export const withOverrideMarker = (display: string, isOverride?: boolean) =>
  isOverride ? (
    <>
      <span aria-hidden="true">* </span>
      <span className="visually-hidden">Firm override: </span>
      {display}
    </>
  ) : (
    display
  );
